
import { defineComponent, ref } from 'vue'
import { Splitpanes, Pane } from 'splitpanes'

import Navbar from '@/components/Navbar.vue'
import Sidebar from '@/components/Sidebar.vue'

import { PaneType, SizeType } from '@/types/PaneTypes'

export default defineComponent({
  components: { Splitpanes, Pane, Navbar, Sidebar },
  setup() {
    // Sizes
    const sidebarSize = ref<SizeType>(localStorage.getItem('sidebarSize') || 20)
    const pageSize = ref<SizeType>(localStorage.getItem('pageSize') || 80)

    const handleResized = ([sidebar, page]: PaneType[]): void => {
      sidebarSize.value = sidebar.size
      pageSize.value = page.size

      localStorage.setItem('sidebarSize', `${sidebar.size}`)
      localStorage.setItem('pageSize', `${page.size}`)
    }

    // Open / Close

    const sidebarOpen = ref<boolean>(
      ['true', null].includes(localStorage.getItem('sidebarOpen'))
    )

    const toggleSidebar = (): void => {
      const newValue = !sidebarOpen.value

      sidebarOpen.value = newValue
      localStorage.setItem('sidebarOpen', `${newValue}`)
    }

    return {
      sidebarSize,
      pageSize,
      handleResized,

      sidebarOpen,
      toggleSidebar
    }
  }
})
